const FALLBACK_ORIGIN = "https://example.com";

function appOrigin() {
  if (typeof window !== "undefined" && window.location?.origin) {
    return window.location.origin;
  }

  return FALLBACK_ORIGIN;
}

export function normalizeRelativeUrl(input) {
  if (!input) return "";

  const value = String(input);
  const parsed = new URL(value, appOrigin());

  return `${parsed.pathname}${parsed.search}${parsed.hash}`;
}

export function getUploadsRouteType(pathname) {
  if (pathname === "/apps/frame/pro/uploads") return "index";
  if (/^\/apps\/frame\/pro\/uploads\/[^/]+\/preview$/.test(pathname)) {
    return "preview";
  }
  if (/^\/apps\/frame\/pro\/uploads\/[^/]+$/.test(pathname)) {
    return "show";
  }

  return null;
}

export function buildUploadsIndexUrl(
  basePath,
  { search = "", page = null, mockupCta = false } = {},
) {
  const parsed = new URL(basePath, appOrigin());
  const trimmedSearch = String(search || "").trim();

  if (trimmedSearch) parsed.searchParams.set("search", trimmedSearch);
  if (page) parsed.searchParams.set("page", page);
  if (mockupCta) parsed.searchParams.set("mockup-cta", "1");

  return normalizeRelativeUrl(parsed.toString());
}

export function removeQueryParam(url, paramName) {
  const parsed = new URL(url, appOrigin());
  parsed.searchParams.delete(paramName);
  return normalizeRelativeUrl(parsed.toString());
}
